import { Component, ViewChild, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { NwbAlertService } from '@wizishop/ng-wizi-bulma';
import { ActivatedRoute, Router } from '@angular/router';
import { createAlertConfig } from 'src/app/shared/factoryconfigAlert';

@Component({
    selector: 'modify-amico-fedele',
    templateUrl: './modify-amico-fedele.component.html',
    styleUrls: ['./modify-amico-fedele.component.css']
})
/** modify-amico-fedele component*/
export class ModifyAmicoFedeleComponent implements OnInit  {
 
  amicoFedele: any;
  @ViewChild('modifyAmicoFedele', { static: true })
  formToSend: NgForm;

    /** modify-amico-fedele ctor */
  constructor(private dataService: DataService, private alertservice: NwbAlertService, private route: ActivatedRoute, private router: Router) {

  }

  ngOnInit(): void {
    this.route.data.subscribe(t => {
      this.amicoFedele = t.dataAmicoFedele;
    });
  }


  modAmicoFedele() {
    if (this.formToSend.invalid) {
      this.alertservice.open(createAlertConfig("Controllare i campi", false)).afterClosed().subscribe();
      return;
    }
    this.dataService.setAmicoFedele(this.amicoFedele).subscribe(() => {
      this.alertservice.open(createAlertConfig("Anagrafica aggiornata", true, 1000)).afterClosed().subscribe(t => {
        this.router.navigate(['/area-utente', 'gruppo']);
      });
    });
  }
}
